import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const RelatedPostCard = ({ item }) => {
  return (
    <figure className="relative-post flex flex-col sm:flex-row gap-4 p-4 rounded-[8px] border-gray-700 shadow border-[1px] slide-in">
      
      <GatsbyImage
        image={
          item.featuredImage.node.localFile.childImageSharp.gatsbyImageData
        }
        className="object-cover -scale-x-100 relative-img w-full max-w-[240px] rounded-[8px]"
        alt={item.featuredImage.node.altText}
      />
      
      <div className="flex flex-col gap-4">
        <Link to={`/blog/${item.slug}`} className="font-[500] text-[24px] leading-[1.2] "> {item.title} </Link>
        <div dangerouslySetInnerHTML={{ __html: item.excerpt }} className="text-[16px] leading-[1.5] "></div>
      </div>
    </figure>
  );
};

export default RelatedPostCard;
